import {CSession,ConectParms,ApiResponseData,RequestPram} from "./securesession/client";
import {reConnectParamerter,keyUpdateParamerter} from "./securesession/keyEx";
import * as resType from "./api_response_type";

export type IupdateItemInfoTbls = {
    ASSETS_TYPE?:number,
    CLASS_ID?:number,
    TAG_ID?:string,
    LEASE_ID?:string|null,
    LEASE_LIMIT?:Date|null,
    RESPONSIBLE?:string|null,
    USER_ID?:string|null,
    POSSION_FLOOR?:number|null,
    POSSION_COOR_X?:number|null,
    POSSION_COOR_Y?:number|null,
    POSSION_COMMENT?:string|null,
    DETAIL_TBL?:string|null,
    STATUS?:number,
    PUR_VENDER?:string|null,
    PUR_DATE?:Date|null,
    MOVE_STATUS?:number|null,
    COMMENT_COMMON?:string|null,
    COMMENT_ADMIN?:string|null,
    GROUP_ID?:string|null,
}
const objectConverter = (obj:{[key:string]:any},convert:Array<{pName:string,type:"Date"|"JSON"}>) => {
    for(const cov of convert){
        const tgt = obj[cov.pName];
        if(!tgt){
            continue;
        }
        switch (cov.type){
            case "Date":{
                if(typeof tgt === "string" || typeof tgt === "number" || tgt instanceof Date){
                    obj[cov.pName] = new Date(tgt);
                }
                break;
            }
            case "JSON":{
                if(typeof tgt === "string"){
                    try{
                        obj[cov.pName] = JSON.parse(tgt);
                    }catch{
                        obj[cov.pName] = undefined;
                    }
                }
                break;
            }
        }
    }
    return obj;
}
export class apiRequest{
    private CSession:CSession;
    
    constructor(parms:ConectParms){
        this.CSession = new CSession(parms);
    }
    public async connect(option?:{ reConnect?: reConnectParamerter,keyUpdate?: keyUpdateParamerter}){
        return await this.CSession.conect(option);
    }
    public getSessionData() {
        return this.CSession.getSessionData();
    }
    public async clearSession(){
        return await this.CSession.conect();
    }

    //API
    public request = {
        session:async ()=>{
            return await this.CSession.request({
                "method":"GET",
                "path":"/api/v1/session",
                "body":{}
            }) as ApiResponseData & {data:resType.sessionData};
        },
        desSession:async ()=>{
            return await this.CSession.request({
                "method":"DELETE",
                "path":"/api/v1/session",
                "wOTT":true,
            }) as ApiResponseData & {data:boolean};
        },
        auth:async (pram:resType.API_auth_req)=>{
            return await this.CSession.request({
                "method":"POST",
                "path":"/api/v1/auth/user",
                "body":pram,
            }) as ApiResponseData & {data:resType.apiResponseData_auth};
        },
        my:{
            changePassword:async (pram:{currentPassword:string,password:string,otpCode?:string}) => {
                const reqPra:resType.API_passwordChange_Req = {
                    "current":pram.currentPassword,
                    "password":pram.password,
                }
                if(pram.otpCode){
                    reqPra.otpToken = pram.otpCode;
                }
                return await this.CSession.request({
                    "method":"PUT",
                    "path":"/api/v1/my/password",
                    "body":reqPra,
                }) as ApiResponseData & {data:resType.API_passwordChange_Res};
            },
            getSalary:async()=>{
                return await this.CSession.request({
                    "method":"GET",
                    "path":`/api/v1/my/salaly.view`,
                }) as ApiResponseData & {data:resType.SalaAPI_GetSalary_Res};
            },
            printSalary:async(ym:string)=>{
                return await this.CSession.request({
                    "method":"GET",
                    "path":`/api/v1/my/salaly.pdf`,
                    "params":{ym}
                }) as ApiResponseData & {data:resType.PdfResponse};
            },
            getBonus:async()=>{
                return await this.CSession.request({
                    "method":"GET",
                    "path":`/api/v1/my/bonus.view`,
                }) as ApiResponseData & {data:resType.SalaAPI_GetSalary_Res};
            },
            printBonus:async(ym:string)=>{
                return await this.CSession.request({
                    "method":"GET",
                    "path":`/api/v1/my/bonus.pdf`,
                    "params":{ym}
                }) as ApiResponseData & {data:resType.PdfResponse};
            },
            getYend:async()=>{
                return await this.CSession.request({
                    "method":"GET",
                    "path":`/api/v1/my/yend_adj.view`,
                }) as ApiResponseData & {data:resType.SalaAPI_GetSalaryTax_Res};
            },
            printYendAdj:async(ym:string)=>{
                return await this.CSession.request({
                    "method":"GET",
                    "path":`/api/v1/my/yend_adj.pdf`,
                    "params":{ym}
                }) as ApiResponseData & {data:resType.PdfResponse};
            },
            printYendTax:async(ym:string)=>{
                return await this.CSession.request({
                    "method":"GET",
                    "path":`/api/v1/my/yend_tax.pdf`,
                    "params":{ym}
                }) as ApiResponseData & {data:resType.PdfResponse};
            },
            getResinSalary:async()=>{
                const res = await this.CSession.request({
                    "method":"GET",
                    "path":`/api/v1/my/resign/salary.view`,
                }) as ApiResponseData & {data:any};
                if(res.statusCode === 200){
                    return {
                        "statusCode":res.statusCode,
                        "debug":res.debug,
                        "data":Object.assign(res.data,{defItem:objectConverter(res.data.defItem,[{"pName":"rdateRaw","type":"Date"},{"pName":"adateRaw","type":"Date"}])}),
                    } as ApiResponseData & {data:resType.SalaAPI_MyResignSalary_Res}
                }
                return res as ApiResponseData & {data:resType.SalaAPI_MyResignSalary_Res};
            },
            printResinSalary:async()=>{
                return await this.CSession.request({
                    "method":"GET",
                    "path":`/api/v1/my/resign/salary.pdf`,
                }) as ApiResponseData & {data:resType.PdfResponse};
            },
            totp:{
                newSecret:async(password:string) => {
                    return await this.CSession.request({
                        "method":"PUT",
                        "path":`/api/v1/my/totp/new`,
                        "body":{password}
                    }) as ApiResponseData & {data:resType.SalaAPI_TOTP_NewSecret_res};
                },
                activateSecret:async(otpToken:string) => {
                    return await this.CSession.request({
                        "method":"PUT",
                        "path":`/api/v1/my/totp/activate`,
                        "body":{otpToken}
                    }) as ApiResponseData & {data:boolean};
                },
                clearSecret:async(password:string,otpToken:string) => {
                    return await this.CSession.request({
                        "method":"PUT",
                        "path":`/api/v1/my/totp/clear`,
                        "body":{password,otpToken}
                    }) as ApiResponseData & {data:boolean};
                },
            },
        },
        pdf:{
            password:async(pram:{userid:string,name:string,depname:string,password:string})=>{
                return await this.CSession.request({
                    "method":"POST",
                    "path":`/api/v1/pdfform/${resType.PDFFormType.password}`,
                    "body":{
                        data:{
                            "-60":pram.userid,
                            "-61":pram.name,
                            "-62":pram.password,
                            "-63":pram.depname,
                        }
                    },
                }) as ApiResponseData & {data:resType.PdfResponse};
            },
            formPreview:async(formname:resType.DefnameTable,pram:{items:{[itemCode:number]:string|number},values:Array<resType.SalaAPI_column_Res>,previewFile?:string})=>{
                const modeStr = ((mode:resType.DefnameTable)=>{
                    switch (mode){
                        case "Pay":return "2";
                        case "Bounus":return "3";
                        case "YEndCab":return "4";
                        case "YEndTax":return "5";
                        default: return null;
                    }
                })(formname);
                if(!modeStr){
                    return;
                }
                const req:RequestPram = {
                    "method":"POST",
                    "path":`/api/v1/pdfform/${modeStr}`,
                    "body":{
                        previewColumn:pram.values,
                        data:pram.items
                    },
                }
                if(pram.previewFile){
                    req.body.preview = pram.previewFile;
                }
                return await this.CSession.request(req) as ApiResponseData & {data:resType.PdfResponse};
            }
        },
        admin:{
            getConfig:async () =>{
                const req:RequestPram = {
                    "method":"GET",
                    "path":`/api/v1/admin/config`,
                }
                return await this.CSession.request(req) as ApiResponseData & {data:resType.SslaAPI_SystemConfig};
            },
            setConfig:async (pram:{period:resType.PeriodConfigSet}) =>{
                const req:RequestPram = {
                    "method":"PUT",
                    "path":`/api/v1/admin/config`,
                    "body":pram
                }
                return await this.CSession.request(req) as ApiResponseData & {data:boolean};
            },
            getUser:async(empcode:string) => {
                const req:RequestPram = {
                    "method":"GET",
                    "path":`/api/v1/admin/user/${empcode}`,
                }
                return await this.CSession.request(req) as ApiResponseData & {data:Array<resType.SalaAPI_user_res>};
            },
            getUsers:async(pram?:{containRetired?:boolean,rawname?:boolean}) => {
                const req:RequestPram = {
                    "method":"GET",
                    "path":`/api/v1/admin/users`,
                }
                if(pram){
                    req.params = {};
                    if(pram.containRetired){
                        req.params .retire = "y";
                    }
                    if(pram.rawname){
                        req.params .raw = "y";
                    }
                }
                return await this.CSession.request(req) as ApiResponseData & {data:Array<resType.SalaAPI_user_res>};
            },
            addUser:async(empcode:string) => {
                const req:RequestPram = {
                    "method":"PUT",
                    "path":`/api/v1/admin/newuser`,
                    "body":{empcode},
                }
                return await this.CSession.request(req) as ApiResponseData & {data:resType.SalaAPI_AddUser_res};
            },
            modUser:async(userID:string,pram:resType.SalaAPI_ModUser_req) => {
                const req:RequestPram = {
                    "method":"PUT",
                    "path":`/api/v1/admin/user/${userID}`,
                    "body":pram,
                }
                return await this.CSession.request(req) as ApiResponseData & {data:boolean};
            },
            resetpassword:async(empcode:string) => {
                const req:RequestPram = {
                    "method":"POST",
                    "path":`/api/v1/admin/resetpassword`,
                    "body":{user:empcode},
                }
                return await this.CSession.request(req) as ApiResponseData & {data:{key:string|null}};
            },
            getTimeProUsers:async (empcode:string) =>{
                const req:RequestPram = {
                    "method":"GET",
                    "path":`/api/v1/admin/tuser/${empcode}`,
                    "params":{"type":"empcode"}
                }
                return await this.CSession.request(req) as ApiResponseData & {data:resType.apiResponseData_timeProUsers};
            },
            refreshTimeProUsers:async () =>{
                const req:RequestPram = {
                    "method":"POST",
                    "path":`/api/v1/admin/matchuserdata`,
                    "body":{
                        "refreshType":"MatchTimePro",
                    } as resType.SalaAPI_Refresh_Req,
                }
                return await this.CSession.request(req) as ApiResponseData & {data:boolean};
            },
            getFormPdf:async(mode:resType.DefnameTable) => {
                const modeStr = ((mode:resType.DefnameTable)=>{
                    switch (mode){
                        case "Pay":return "2";
                        case "Bounus":return "3";
                        case "YEndCab":return "4";
                        case "YEndTax":return "5";
                        default: return null;
                    }
                })(mode);
                if(!modeStr){
                    return;
                }
                const req:RequestPram = {
                    "method":"GET",
                    "path":`/api/v1/admin/form/skelton/${modeStr}.pdf`,
                }
                return await this.CSession.request(req) as ApiResponseData & {data:Uint8Array};
            },
            uploadFormPdf:async (pdfData:Uint8Array) => {
                const req:RequestPram = {
                    "method":"POST",
                    "path":`/api/v1/admin/form/skeltontemp`,
                    "body":pdfData,
                }
                return await this.CSession.request(req) as ApiResponseData & {data:string};
            },
            getFormConfig:async(mode:resType.DefnameTable) => {
                const modeStr = ((mode:resType.DefnameTable)=>{
                    switch (mode){
                        case "Pay":return "2";
                        case "Bounus":return "3";
                        case "YEndCab":return "4";
                        case "YEndTax":return "5";
                        default: return null;
                    }
                })(mode);
                if(!modeStr){
                    return;
                }
                const req:RequestPram = {
                    "method":"GET",
                    "path":`/api/v1/admin/form/column/${modeStr}`,
                }
                return await this.CSession.request(req) as ApiResponseData & {data:resType.SalaAPI_FromColumn_Respons};
            },
            updateFormColumn:async(mode:resType.DefnameTable,columns:Array<resType.SalaAPI_column_Res>,pdf?:string) => {
                const modeStr = ((mode:resType.DefnameTable)=>{
                    switch (mode){
                        case "Pay":return "2";
                        case "Bounus":return "3";
                        case "YEndCab":return "4";
                        case "YEndTax":return "5";
                        default: return null;
                    }
                })(mode);
                if(!modeStr){
                    return;
                }
                const reqBody:resType.API_FromColumn_Request = {
                    colomun:columns,
                }
                if(pdf){
                    reqBody.tempPdf = pdf;
                }
                const req:RequestPram = {
                    "method":"PUT",
                    "path":`/api/v1/admin/form/column/${modeStr}`,
                    "body":reqBody,
                }
                return await this.CSession.request(req) as ApiResponseData & {data:boolean};
            },
            getViewConfig:async(mode:resType.DefnameTable) => {
                const modeStr = ((mode:resType.DefnameTable)=>{
                    switch (mode){
                        case "Pay":return "1";
                        case "Bounus":return "2";
                        case "YEndCab":return "3";
                        case "YEndTax":return "4";
                        default: return null;
                    }
                })(mode);
                if(!modeStr){
                    return;
                }
                const req:RequestPram = {
                    "method":"GET",
                    "path":`/api/v1/admin/view/column/${modeStr}`,
                }
                return await this.CSession.request(req) as ApiResponseData & {data:resType.API_ViewColumn_Respons};
            },
            updateViewConfig:async(mode:resType.DefnameTable,data:resType.viewDegin) => {
                const modeStr = ((mode:resType.DefnameTable)=>{
                    switch (mode){
                        case "Pay":return "1";
                        case "Bounus":return "2";
                        case "YEndCab":return "3";
                        case "YEndTax":return "4";
                        default: return null;
                    }
                })(mode);
                if(!modeStr){
                    return;
                }
                const req:RequestPram = {
                    "method":"PUT",
                    "path":`/api/v1/admin/view/column/${modeStr}`,
                    "body":data,
                }
                return await this.CSession.request(req) as ApiResponseData & {data:resType.API_ViewColumn_Respons};
            },
            getResignSalary:async() => {
                const req:RequestPram = {
                    "method":"GET",
                    "path":`/api/v1/admin/resign/salary`,
                }
                return await this.CSession.request(req) as ApiResponseData & {data:resType.SalaAPI_ResignSalary_Res};
            },
            updateResignSalary:async(data:resType.SalaAPI_ResignSalary_Req,overwrite:"sync"|"true"|"false") => {
                const req:RequestPram = {
                    "method":"PUT",
                    "path":`/api/v1/admin/resign/salary`,
                    "params":{ow:overwrite},
                    "body":data,
                }
                return await this.CSession.request(req) as ApiResponseData & {data:boolean};
            },
        }
    }
}
